import { render, staticRenderFns } from "./PartnerApps.vue?vue&type=template&id=6970f128"
import script from "./PartnerApps.vue?vue&type=script&lang=ts"
export * from "./PartnerApps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports